import React from 'react'
import "./BankOffers.css"

const BankOffers = () => {
  return (
    <div>
    <div style={{marginTop:"50px",marginBottom:"-20px"}}>
         <h1>Bank Offers</h1>
    </div>
    <div className='BankOffers'>
        
        <div>
            <img src="https://www.bigbasket.com/media/customPage/77880b23-0233-4fad-b54a-a93c998e0d20/7f6ddfd5-93af-4bbd-a250-ce828daa63d6/2a46997a-8de3-47ba-af2d-25e7613f233d/t1_hp_aff_m_bob_360_101122.jpg" alt="Not-Found" />
            
        </div>
        <div>
        <img src="https://www.bigbasket.com/media/customPage/77880b23-0233-4fad-b54a-a93c998e0d20/7f6ddfd5-93af-4bbd-a250-ce828daa63d6/2a46997a-8de3-47ba-af2d-25e7613f233d/t1_hp_aff_m_IndusInd_360_101122.jpg" alt="Not-Found" />
        </div>
        <div>
        <img src="https://www.bigbasket.com/media/customPage/77880b23-0233-4fad-b54a-a93c998e0d20/7f6ddfd5-93af-4bbd-a250-ce828daa63d6/2a46997a-8de3-47ba-af2d-25e7613f233d/t1_hp_aff_m_rbl_360_101122.jpg" alt="Not-Found" />
        </div>
        <div>
        <img src="https://www.bigbasket.com/media/customPage/77880b23-0233-4fad-b54a-a93c998e0d20/7f6ddfd5-93af-4bbd-a250-ce828daa63d6/2a46997a-8de3-47ba-af2d-25e7613f233d/t1_hp_aff_m_kotak_360_101122.jpg" alt="Not-Found" />
        </div>
    </div>
    </div>
  )
}

export default BankOffers